import Banner from "../../sections/common/banner";
import ItodoImage from "../../elements/itodo-img";
import { NavLink } from "react-router-dom";
import { publicUrlFor } from "../../../globals/constants";
import { bannerData } from "../../../globals/banner";

function GalleryPage() {
    return (
        <>
            <Banner _data={bannerData.gallery} />

            <div className="section-full p-t100 p-b70 mobile-page-padding">
                <div className="container">
                    {/* Filter Nav END */}
                    {/* GALLERY CONTENT START */}
                    <ul className="masonry-outer mfp-gallery work-grid row clearfix list-unstyled m-b0">
                        {/* COLUMNS 1 */}
                        <li className="masonry-item cat-1 col-lg-4 col-md-6 col-sm-6 m-b30">
                            <div className="sx-gallery-block">
                                <div className="sx-gallery-media sx-img-overlay">
                                    <NavLink to="/portfolio/detail"><ItodoImage src="/images/info-team/christine.jpeg" alt="" /></NavLink>
                                    <a href={publicUrlFor("/images/info-team/christine.jpeg")} className="sx-gallery-link elem" data-lcl-txt="Regulatory Compliance System" data-lcl-author="someone" data-lcl-thumb={publicUrlFor("/images/info-team/dorris.jpeg")}><i className="flaticon-up-right-arrow" /></a>
                                </div>
                            </div>
                        </li>
                        {/* COLUMNS 2 */}
                        <li className="masonry-item cat-2 col-lg-4 col-md-6 col-sm-6 m-b30">
                            <div className="sx-gallery-block">
                                <div className="sx-gallery-media sx-img-overlay">
                                    <NavLink to="/portfolio/detail"><ItodoImage src="images/info-team/dorris.jpeg" alt="" /></NavLink>
                                    <a href={publicUrlFor("images/info-team/dorris.jpeg")} className="sx-gallery-link elem" data-lcl-txt="Regulatory Compliance System" data-lcl-author="someone" data-lcl-thumb={publicUrlFor("images/gallery/2.jpg")}><i className="flaticon-up-right-arrow" /></a>
                                </div>
                            </div>
                        </li>
                        {/* COLUMNS 3 */}
                        <li className="masonry-item cat-3 col-lg-4 col-md-6 col-sm-6 m-b30">
                            <div className="sx-gallery-block">
                                <div className="sx-gallery-media sx-img-overlay">
                                    <NavLink to="/portfolio/detail"><ItodoImage src="images/services/Benefits-02.webp" alt="" /></NavLink>
                                    <a href={publicUrlFor("images/services/Benefits-02.webp")} className="sx-gallery-link elem" data-lcl-txt="Regulatory Compliance System" data-lcl-author="someone" data-lcl-thumb={publicUrlFor("images/gallery/3.jpg")}><i className="flaticon-up-right-arrow" /></a>
                                </div>
                            </div>
                        </li>
                    </ul>
                    {/* GALLERY CONTENT END */}
                </div>
            </div>

        </>
    )
}

export default GalleryPage;